import styled from 'styled-components'

export const StyledImage = styled.img`
  height: 100%;
  object-fit: cover;
  width: 100%;
`

export const StyledMapWrapper = styled.div`
  height: 11.25rem;
  margin-bottom: 1.5rem;
  position: relative;
`

export const StyledSvgWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`
